import { Row, Col, Card, Progress, Statistic } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { PageHeader } from '../../components/common/PageHeader';
import { useSystemHealth, useSystemMetrics } from '../../hooks/useSystem';

function ServiceCard({ name, status }: { name: string; status: string }) {
  const isHealthy = status === 'healthy';
  return (
    <Card>
      <Statistic
        title={name}
        value={status}
        valueStyle={{ color: isHealthy ? '#3f8600' : status === 'unknown' ? '#8c8c8c' : '#cf1322', fontSize: 16 }}
        prefix={isHealthy ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
      />
    </Card>
  );
}

export function SystemHealthPage() {
  const { data: health } = useSystemHealth();
  const { data: metrics, isLoading: metricsLoading } = useSystemMetrics();

  return (
    <>
      <PageHeader title="System Health" subtitle={health ? `Overall: ${health.status} | v${health.version}` : 'Loading...'} />
      <Row gutter={[16, 16]}>
        <Col xs={12} sm={6}><ServiceCard name="Database" status={health?.database || 'unknown'} /></Col>
        <Col xs={12} sm={6}><ServiceCard name="Redis" status={health?.redis || 'unknown'} /></Col>
        <Col xs={12} sm={6}><ServiceCard name="Celery" status={health?.celery || 'unknown'} /></Col>
        <Col xs={12} sm={6}><ServiceCard name="Storage" status={health?.storage || 'unknown'} /></Col>
      </Row>
      <Card title="System Metrics" style={{ marginTop: 16 }} loading={metricsLoading}>
        <Row gutter={[32, 16]}>
          <Col span={8}>
            <div style={{ textAlign: 'center' }}>
              <Progress type="dashboard" percent={metrics?.cpu_percent ?? 0} format={(p) => `${p}%`} />
              <div>CPU Usage</div>
            </div>
          </Col>
          <Col span={8}>
            <div style={{ textAlign: 'center' }}>
              <Progress type="dashboard" percent={metrics?.memory_percent ?? 0} format={(p) => `${p}%`} status={((metrics?.memory_percent ?? 0) > 80) ? 'exception' : 'normal'} />
              <div>Memory Usage</div>
            </div>
          </Col>
          <Col span={8}>
            <div style={{ textAlign: 'center' }}>
              <Progress type="dashboard" percent={metrics?.disk_percent ?? 0} format={(p) => `${p}%`} status={((metrics?.disk_percent ?? 0) > 80) ? 'exception' : 'normal'} />
              <div>Disk Usage</div>
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
}
